export default __webpack_public_path__ + "static/media/T_59_desktop.e7c1fb9a.jpg";